import { render } from "./InputCopy.vue?vue&type=template&id=37d73f14&scoped=true"
import script from "./InputCopy.vue?vue&type=script&lang=js"
export * from "./InputCopy.vue?vue&type=script&lang=js"

import "./InputCopy.vue?vue&type=style&index=0&id=37d73f14&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d73f14"]])

export default __exports__